import { useLayoutEffect, useRef } from 'react';

export function useFitText<T extends HTMLElement = HTMLElement>(
  value: string,
  options: { maxLines?: number; minScale?: number; step?: number } = {},
) {
  const { maxLines = 2, minScale = 0.5, step = 0.94 } = options;
  const ref = useRef<T | null>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty('--fit-scale', '1');
    let scale = 1;
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    if (!Number.isFinite(lineHeight) || lineHeight <= 0) return;
    const limit = lineHeight * maxLines + 1;
    // Vertical: too many lines. Horizontal: a single word too wide for the
    // column (only catches when the value is allowed to overflow rather than
    // break — see overflow-wrap: normal in IDCard.scss).
    while (
      (el.scrollHeight > limit || el.scrollWidth > el.clientWidth) &&
      scale > minScale
    ) {
      scale *= step;
      el.style.setProperty('--fit-scale', scale.toFixed(3));
    }
  }, [value, maxLines, minScale, step]);

  return ref;
}
